var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRynPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ryn"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "89.88 51.8 89.88 78.68 132.86 78.68 132.86 51.8",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.25 51.44 135.34 51.44 131.33 47.33 90.83 47.33 86.25 51.44",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "91.79 46.62 110.51 25.89 129.8 46.8 143.29 46.66 122.55 27.68 110.51 25.89",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.91,
    y1: 77.64,
    x2: 132.86,
    y2: 78.68,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.24,
    y: 34.47,
    width: 2.8,
    height: 3.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.39,
    y: 56.98,
    width: 11.53,
    height: 21.76,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.54,
    y1: 51.03,
    x2: 94.66,
    y2: 47.35,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.37,
    y1: 50.91,
    x2: 98.54,
    y2: 47.93,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.05,
    y1: 51.27,
    x2: 103.12,
    y2: 47.69,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.93,
    y1: 51.03,
    x2: 106.56,
    y2: 47.93,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.61,
    y1: 51.15,
    x2: 127.19,
    y2: 47.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.01,
    y1: 51.03,
    x2: 122.61,
    y2: 47.69,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.66,
    y1: 51.15,
    x2: 118.02,
    y2: 47.57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.17,
    y1: 50.91,
    x2: 112.55,
    y2: 47.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.06,
    y1: 28.51,
    x2: 124.55,
    y2: 30.06,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "143.29 46.66 147.57 51.08 135.34 51.44",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.77,
    y: 60.55,
    width: 11.41,
    height: 5.91,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.16 51.8 139.16 78.68 182.15 78.68 182.15 51.8",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.54 51.44 184.63 51.44 180.62 47.33 140.12 47.33 135.54 51.44",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "141.08 46.62 159.8 25.89 179.09 46.8 192.58 46.66 171.83 27.68 159.8 25.89",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187.92,
    y1: 77.69,
    x2: 182.15,
    y2: 78.68,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.52,
    y: 34.47,
    width: 2.8,
    height: 3.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.67,
    y: 56.98,
    width: 11.53,
    height: 21.76,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.81,
    y: 56.81,
    width: 12.1,
    height: 10.79,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.82,
    y1: 51.03,
    x2: 143.94,
    y2: 47.35,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.66,
    y1: 50.91,
    x2: 147.82,
    y2: 47.93,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.34,
    y1: 51.27,
    x2: 152.41,
    y2: 47.69,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.21,
    y1: 51.03,
    x2: 155.85,
    y2: 47.93,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.9,
    y1: 51.15,
    x2: 176.48,
    y2: 47.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.3,
    y1: 51.03,
    x2: 171.89,
    y2: 47.69,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.95,
    y1: 51.15,
    x2: 167.31,
    y2: 47.57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.45,
    y1: 50.91,
    x2: 161.83,
    y2: 47.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.34,
    y1: 28.51,
    x2: 173.84,
    y2: 30.06,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "192.58 46.66 196.86 51.08 184.63 51.44",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.98,
    y: 54.52,
    width: 6.59,
    height: 4.01,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "192.58 46.66 196.86 51.08 184.63 51.44",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.98,
    y: 54.52,
    width: 6.59,
    height: 4.01,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "188.45 51.8 188.45 78.68 231.43 78.68 231.43 51.8",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.82 51.44 233.92 51.44 229.9 47.33 189.41 47.33 184.82 51.44",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "190.36 46.62 209.08 25.89 228.38 46.8 241.86 46.66 221.12 27.68 209.08 25.89",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "243.47 51.46 243.47 76.72 242.89 76.72 231.43 78.68",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.81,
    y: 34.47,
    width: 2.8,
    height: 3.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.96,
    y: 56.98,
    width: 11.53,
    height: 21.76,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.1,
    y: 56.81,
    width: 12.1,
    height: 10.79,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.11,
    y1: 51.03,
    x2: 193.23,
    y2: 47.35,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.95,
    y1: 50.91,
    x2: 197.11,
    y2: 47.93,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.63,
    y1: 51.27,
    x2: 201.7,
    y2: 47.69,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.5,
    y1: 51.03,
    x2: 205.13,
    y2: 47.93,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.18,
    y1: 51.15,
    x2: 225.76,
    y2: 47.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.58,
    y1: 51.03,
    x2: 221.18,
    y2: 47.69,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.23,
    y1: 51.15,
    x2: 216.6,
    y2: 47.57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.74,
    y1: 50.91,
    x2: 211.12,
    y2: 47.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.63,
    y1: 28.51,
    x2: 223.12,
    y2: 30.06,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "241.86 46.66 246.14 51.08 233.92 51.44",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.27,
    y: 54.52,
    width: 6.59,
    height: 4.01,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.48,
    y1: 57,
    x2: 226.37,
    y2: 66.84,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.48,
    y1: 67.51,
    x2: 226.66,
    y2: 57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40.59 51.8 40.59 78.68 83.58 78.68 83.58 51.8",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.96 51.44 86.06 51.44 82.05 47.33 41.55 47.33 36.96 51.44",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.5 46.62 61.23 25.89 80.52 46.8 94.01 46.66 73.26 27.68 61.23 25.89",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.01,
    y1: 77.58,
    x2: 83.58,
    y2: 78.68,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.95,
    y: 34.47,
    width: 2.8,
    height: 3.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.1,
    y: 56.98,
    width: 11.53,
    height: 21.76,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.24,
    y: 56.81,
    width: 12.1,
    height: 10.79,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.25,
    y1: 51.03,
    x2: 45.37,
    y2: 47.35,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.09,
    y1: 50.91,
    x2: 49.25,
    y2: 47.93,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.77,
    y1: 51.27,
    x2: 53.84,
    y2: 47.69,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.64,
    y1: 51.03,
    x2: 57.28,
    y2: 47.93,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.33,
    y1: 51.15,
    x2: 77.91,
    y2: 47.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.72,
    y1: 51.03,
    x2: 73.32,
    y2: 47.69,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.38,
    y1: 51.15,
    x2: 68.74,
    y2: 47.57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.88,
    y1: 50.91,
    x2: 63.26,
    y2: 47.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.77,
    y1: 28.51,
    x2: 75.27,
    y2: 30.06,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "94.01 46.66 98.28 51.08 86.06 51.44",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.41,
    y: 54.52,
    width: 6.59,
    height: 4.01,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.62,
    y1: 57,
    x2: 78.51,
    y2: 66.84,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.62,
    y1: 67.51,
    x2: 78.8,
    y2: 57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.59,
    y1: 78.68,
    x2: 9.86,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.13,
    y1: 78.68,
    x2: 26.39,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.66,
    y1: 78.68,
    x2: 42.93,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.2,
    y1: 78.68,
    x2: 59.46,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.73,
    y1: 78.68,
    x2: 76,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.27,
    y1: 78.68,
    x2: 92.53,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.8,
    y1: 78.68,
    x2: 109.07,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.34,
    y1: 78.68,
    x2: 125.6,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.88,
    y1: 78.68,
    x2: 142.14,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.41,
    y1: 78.68,
    x2: 158.68,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.95,
    y1: 78.68,
    x2: 175.21,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.48,
    y1: 78.68,
    x2: 191.75,
    y2: 84.11,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.21
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRynPop);
export default __webpack_public_path__ + "static/media/ryn_pop.a99503f35a408656f85e698a37b38e69.svg";
export { ForwardRef as ReactComponent };